import constants from '../../config/constants';
import { carouselActions, recoAnalytics } from '../../utils/recoAnalytics';

const useRecommendedProductsHook = ({ title, slots, products, tenant }) => {
  const onProductClick = (indexPod) => {
    const variantId = products?.[indexPod]?.id ?? '';
    const country = tenant === constants.TENANT_TYPES.SODIMAC_CL ? 'SOCL' : 'SOPE';
    recoAnalytics.click({
      carouselKey: 'CR_RecommendationCarousel',
      siteName: country,
      action: carouselActions.clickToRate,
      carouselName: title,
      skuId: variantId,
      podPositionInCarousel: indexPod + 1,
      lengthPodsInCarousel: products.length,
      slotId: slots,
    });
  };

  const onProductImpression = (indexPod) => {
    const productId = products?.[indexPod]?.id ?? '';
    recoAnalytics.impression({
      carouselName: title,
      skusViewed: [productId],
    });
  };

  return {
    onProductClick,
    onProductImpression,
  };
};

export { useRecommendedProductsHook };
